import { FormattedMessage, useIntl } from 'react-intl';
import { ReactNode } from 'react';
import { cx } from '@emotion/css';

import { useStyles } from './facts.styles';
import { items1Left, items1Right, items4, items2Top, items2Bottom, items3Top, items3Bottom, notes } from './items/items';
import headerImg from '../../../../assets/images/facts/header.png';
import { Header } from '../layout-primary/header';
import { List } from './list/list';
import { Page } from '../page/page';

export const Facts = (): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <Page title={intl.formatMessage({ id: 'facts.pageTitle' })}>
      <Header />
      <main>
        <div className={classes.banner}>
          <div className={classes.layout}>
            <div className={classes.wrapper}>
              <h1 className={classes.title}>{intl.formatMessage({ id: 'facts.title' }, { noBreak: <>&nbsp;</> })}</h1>
              <p className={classes.description}><FormattedMessage id="facts.description" /></p>
            </div>
            <img className={classes.image} src={headerImg} alt="" />
          </div>
        </div>
        <p className={cx(classes.content, classes.layout)}>
          {intl.formatMessage({ id: 'facts.content' }, { noBreak: <>&nbsp;</> })}
        </p>
        <div className={cx(classes.lists, classes.layout)}>
          <List itemsFirst={items1Left} itemsSecond={items1Right} />
          <List itemsFirst={items2Top} itemsSecond={items2Bottom} isSpanFirst />
          <List itemsFirst={items3Top} itemsSecond={items3Bottom} isSpanLast />
          <List itemsFirst={items4} />
        </div>
        <ul className={cx(classes.notes, classes.layout)}>
          {notes.map((note) => (
            <li key={note}>
              {intl.formatMessage(
                { id: note },
                {
                  sup: (chunks: ReactNode) => <sup>{chunks}</sup>,
                  link: (chunks: ReactNode | string) => (
                    <a
                      href={'https://www.' + chunks as string}
                      className={classes.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >{chunks}</a>),
                  div: (chunks: ReactNode) => <div>{chunks}</div>,
                },
              )}
            </li>
          ))}
        </ul>
        <p className={classes.legal}><FormattedMessage id="facts.legalNumber" /></p>
      </main>
    </Page>
  );
};
